import Icon from "@ant-design/icons";

const Svg = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd"
            d="M11.9604 17.3913C11.2238 18.2029 10.0313 18.2029 9.29658 17.3913L5.29898 12.9888C4.16753 11.2871 6.51322 9.33297 7.90775 10.8734L10.5734 13.8084L15.7875 6.70764C17.6912 4.70959 20.2295 7.37368 18.3258 9.37176L11.9604 17.3913Z"
            fill="#51258F"/>
    </svg>
  )
}
export const MyIcon = (props: any) => <Icon component={Svg} {...props} />;